import $ from "jquery";
import {removeActiveBackdrop} from "../modal-backdrop";
import {scrollBarWidth} from "Core/helpers/ScrollBarHelper";

const TABLET_RESOLUTION = 1019;

export const bindDisplayEventsToModal = () => {
    const isDesktop = () => {
        return window.outerWidth > TABLET_RESOLUTION;
    };

    const modal = $('.modal');

    modal.on('show.bs.modal', function (e) {
        if (isDesktop()) {
            $(".wrapper__footer").css("padding-left", scrollBarWidth());
            $(".content-row__centered--footer").css("padding-right", scrollBarWidth() + scrollBarWidth());
            $(".header__inner").css("margin-right", scrollBarWidth());
        }
    });

    modal.on('hidden.bs.modal', function (e) {
        $('#modal-block').html('');
    });

    $(document).mouseup(function (e) {
        const container = $(".modal-content");
        const modalShow = $('.modal.show');

        if (e.which === 1) {
            if (!container.is(e.target) && container.has(e.target).length === 0) {
                if (modalShow.data('redirectUrl') !== undefined) {
                    window.location.href = modalShow.data('redirectUrl');
                }

                removeActiveBackdrop();
            }
        }
    });
};
